module.exports = __webpack_public_path__ + "img/3.49d8f3b4.png";